import { Controller, useFormContext } from "react-hook-form";

import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import { CustomInputField, CustomSelect } from "../../../ui";
import { StatusEnum, statusLabels } from "../../../shared";

export const GeneralInformationSection = () => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
          <CustomInputField
            required
            control={control}
            name="name"
            label="Nama"
            register={register}
            helperText={errors.name?.message}
            error={Boolean(errors.name)}
            InputProps={{
              placeholder: "Cth: Gudang ABC",
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
          <CustomInputField
            control={control}
            name="description"
            label="Deskripsi"
            register={register}
            helperText={errors.description?.message}
            error={Boolean(errors.description)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <Controller
            control={control}
            name="damagedGoodsWarehouse"
            render={({ field, fieldState }) => (
              <CustomSelect
                required
                value={field.value}
                onChange={field.onChange}
                id="damagedGoodsWarehouse"
                label="Khusus Barang Rusak"
                options={Object.values([
                  { value: true, label: "Ya" },
                  { value: false, label: "Tidak" },
                ]).map((option) => ({
                  value: option.value,
                  label: option.label,
                }))}
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <Controller
            control={control}
            name="status"
            render={({ field, fieldState }) => (
              <CustomSelect
                required
                value={field.value}
                onChange={field.onChange}
                id="status"
                label="Status"
                options={Object.values(StatusEnum).map((value) => ({
                  value: value,
                  label: statusLabels[value],
                }))}
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 8, lg: 6 }}>
          <CustomInputField
            control={control}
            name="address"
            label="Alamat"
            register={register}
            helperText={errors.address?.message}
            error={Boolean(errors.address)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="postalCode"
            label="Kode POS"
            register={register}
            helperText={errors.postalCode?.message}
            error={Boolean(errors.postalCode)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="city"
            label="Kota"
            register={register}
            helperText={errors.city?.message}
            error={Boolean(errors.city)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="province"
            label="Provinsi"
            register={register}
            helperText={errors.province?.message}
            error={Boolean(errors.province)}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <CustomInputField
            control={control}
            name="country"
            label="Negara"
            register={register}
            helperText={errors.country?.message}
            error={Boolean(errors.country)}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
